module.exports = __webpack_public_path__ + "static/heavy_yuleba1-e697513f2cfe8f5c9b4dd8045a51cb03.jpg";